import { Service } from '@angular/core';
import { Observable } from 'rxjs';
import { IntradayChart } from '../models/intraday-chart.model';
import { BaseService } from './base.service';

/** Contract lists and figures come from `MarketDataStore`; this is the per-symbol chart only. */
@Service()
export class SymbolsService extends BaseService {
	/**
	 * Current-session price series for one symbol, used to draw the symbol-card sparkline.
	 * The endpoint expects the isin lower-cased (`imeonline_deposit_42`), while `symbolinfo`
	 * reports it upper-cased — so it's folded here rather than at every call site.
	 */
	getIntradayChart(isin: string): Observable<IntradayChart> {
		return this.http.get<IntradayChart>(`${this.kalaApiPath}/symbols/${isin.toLowerCase()}/intraday-chart`);
	}
}
